export default __webpack_public_path__ + "static/media/teeth property bg.99bfde42.svg";